import React, { Component } from 'react';

class DogTab extends Component {

	render(){
		return (
			<React.Fragment>
			
				<div className="tab-container float-left"  onClick= {e => this.props.handleClick(this.props.uid)}>
					<img alt="dog profile" id="avatar-tab" className="float-left" src={this.props.avatar}/>
						<div className="d-inline float-left">
							<p className="dog-info" id="dog-name">{this.props.name}</p>						
							<button className="dog-info" id="dog-profile">See Profile</button>
						</div>	
				     </div>
				</React.Fragment>
			);
	};
}




export default DogTab;